import * as React from 'react';
import {
    ITranslatedComponent,
} from '../redux/reducers/generalReducer';
import {RouteComponentProps, withRouter} from 'react-router';
import {Header, Icon, Menu, Modal, ModalActions, ModalContent, ModalDescription, ModalHeader, Popup, Image, Table} from "semantic-ui-react";
import ProMTLogo from '../components/ProMTLogo';
import {MaintenanceListDto, MenuDto, UserDetailsDto} from '../services/Client';
import AppBar from '../components/AppBar/AppBar';
import {LOCALTOKENKEY, POSTLOGOUTURL} from '../services/BaseClient';
import {currentLinkName} from "./OptionsView/LinkName";
import * as _ from "lodash";
import {compose, Dispatch} from "redux";
import {translate} from "react-i18next";
import {connect} from "react-redux";
import GeneralActions from "../redux/actions/GeneralActions";
import {IUserSettings} from 'src/data/IUserSettings';
import SlideFromLeft from '../components/NavLink/SlideFromLeft';
import SlideFromTop from '../components/NavLink/SlideFromTop';
import {ILocationTranslation, ISubstitute, ITextAndIcon} from 'src/components/GeneralInterfaces';
import {selectBaseLinks, selectClient, selectLocationTranslations, selectSwitchHeaderMode, selectUserDetails, selectUserSettings} from '../redux/selectors';
import {IReduxState} from 'src/redux/IReduxState';
import HATEOASClient from 'src/services/HATEOASClient';
import Button from 'src/components/Button';
import TextField from "src/components/TextField";
import TextFieldRegEx from 'src/components/TextFieldRegEx';
import {RegexFactory} from 'src/services/ColumnFactory';
import {renderErrorToast} from 'src/utils/FeedbackMessageUtils';
import {selectMaintenanceStatus} from 'src/redux/selectors/generalSelectors';

export const getClassBasedOnEnvironment = (rootClass: string) => {
    if (window.location.hostname === 'localhost' || window.location.hostname === 'cdn.promtdev.aws.platform.porsche-preview.cloud') {
        rootClass = `${rootClass} env-development`;
    } else if (window.location.hostname === 'cdn.promtstadev.aws.platform.porsche-preview.cloud') {
        rootClass = `${rootClass} env-staging`;
    }
    return rootClass;
};
interface IMapDispatchToProps {
    changeLanguage: () => void;
    changeTableHeader: () => void;
    reset: () => void;
}

interface IMapStateToProps {
    locationTranslations: ILocationTranslation[];
    userSettings: IUserSettings;
    switchHeaderMode: boolean;
    userDetails: UserDetailsDto | undefined;
    client: HATEOASClient;
    baseLinks: MenuDto | undefined;
    state: IReduxState;
    maintenanceStatus: MaintenanceListDto;

}

interface IOwnProps { }

interface BreadCrumbsProps extends
    IMapStateToProps,
    IMapDispatchToProps,
    ITranslatedComponent,
    RouteComponentProps<any> {
}

interface BreadCrumbsState {
    open: boolean;
    department: string;
    email: string;
    isValid: boolean;
    headerColor: string;
}

// only internally used data structure while building the bread crumbs
interface IMatchAndTranslation {
    match: RegExpMatchArray;
    translation: ILocationTranslation;
    link: string;
}

class BreadCrumbs extends React.Component<BreadCrumbsProps, BreadCrumbsState> {
    constructor(props: BreadCrumbsProps) {
        super(props);
        this.logout = this.logout.bind(this);
        this.state = {
            open: false,
            department: '',
            email: '',
            isValid: false,
            headerColor: '#e3e4e4'
        };
    }
    // helper method to navigate to somewhere
    navigateTo(path: string): void {
        this.props.history.push(path);
    }
    componentWillReceiveProps(nextProps: Readonly<BreadCrumbsProps>, nextContext: any): void {
        if (nextProps.userDetails !== this.props.userDetails) {
            if (this.props.userDetails && this.props.userDetails && !this.props.userDetails.department)
                this.setState({open: true});
        }
    }

    /**
     * Renders user details in a form that fits in the header / footer.
     * Renders:
     *  CN, Departament and Loginname
     */
    renderUserDetails = (userDetails?: UserDetailsDto) => {

        if (userDetails !== undefined)
            return (
                <div className={getClassBasedOnEnvironment('user-details')}>
                    <ul>
                        <li> {userDetails.displayName !== undefined ? userDetails.displayName : ''} </li>
                        <li> | </li>
                        <li> {userDetails.department !== undefined ? userDetails.department : ''} </li>
                        <li> | </li>
                        <li> {userDetails.cn !== undefined ? userDetails.cn : ''} </li>
                    </ul>
                </div>
            );

        return (<> </>);
    }

    private logout() {
        window.open(localStorage.getItem(POSTLOGOUTURL) || '', '_self');
        sessionStorage.removeItem(LOCALTOKENKEY);
        localStorage.removeItem('isldap');
        localStorage.clear();
        sessionStorage.clear();
    }
    private onUpdateInfo() {
        if (this.state.department.length > 0 && this.state.email.length > 0 && this.state.email.includes('@') && this.state.email.includes('.')) {
            const pathUser = this.props.baseLinks && this.props.client
                .PATCH_updateUserData(this.props.baseLinks)
                .execute({department: this.state.department, email: this.state.email});
            if (pathUser) {
                pathUser.then(() => {
                    window.location.reload();
                }).catch((reason: any) => {
                    renderErrorToast({
                        message: "ERRORS:ERROR_LOADING_CHILD_OPTIONS",
                        details: reason,
                        timestamp: Date.now()
                    });
                    return false;
                });
            }
        } else {
            this.setState({isValid: false});
        }

    }
    private validateEmail(email: string) {
        // Regular expression pattern for validating email addresses
        const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

        // Check if the email matches the pattern
        if (emailPattern.test(email)) {
            // Extract domain from the email address
            const domain = email.split('@')[1];

            // Check if the domain is 'porsche.de' or 'mhp.com'
            if (domain === 'porsche.de' || domain === 'mhp.com') {
                return true; // Valid email with allowed domain
            }
        }

        return false; // Invalid email or domain not allowed
    }

    private isValidData() {
        if (this.state.department.length > 0 && this.state.email.length > 0) {
            if (this.state.email.includes('@') && this.state.email.includes('.') && this.validateEmail(this.state.email) && this.state.department.length < 6) {
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    }
    // render the bread crumbs
    renderBreadCrumbs(): JSX.Element {
        if (this.props.maintenanceStatus && this.props.maintenanceStatus.elements && this.props.maintenanceStatus.elements[0].active) {
            return <></>;
        }
        const hasSupportRole = this.props.baseLinks && this.props.client.GET_supportArea(this.props.baseLinks).canExecute();
        const hasChatbotRole = this.props.baseLinks && this.props.client.GET_promtChatCatArea(this.props.baseLinks).canExecute();
        // array to store found matches
        let matchBox: IMatchAndTranslation[] = [];

        let pathname = this.props.location.pathname;

        // check for all (in app's state) defined translations for bread crumbs if they should be applied
        this.props.locationTranslations.forEach((value) => {
            let matches = value.pattern instanceof RegExp ? pathname.match(value.pattern) : pathname.match("(" + value.pattern + ")($|/)");
            // if the specific translatin matches we store it for later use
            if (matches)
                matchBox.push({match: matches, translation: value, link: pathname.substr(0, (matches.index ? matches.index : 0) + matches[0].length)});
        });

        // we sort the according their index in the path name where they matched - we want to apply them from front to back
        matchBox.sort((a: IMatchAndTranslation, b: IMatchAndTranslation) => a.match.index && b.match.index ? a.match.index - b.match.index : 0);

        // result array to create bread crumbs from
        let result: ITextAndIcon[] = [];

        // apply all matching translations
        // order is:
        // - call replace function if available
        // - use substitutes if available
        //   - it is an array of substitutes apply them one by one (if for a match nothing is supplied it is simply ignored)
        //      - if the substitue is a string just put this string in the result array
        //      - if it is a function call it with the found match and put it's return value into the result array
        //   - it is a string then just put it into the result array
        matchBox.forEach((value: IMatchAndTranslation) => {
            let t = value.translation;

            if (t.replace)
                result.concat(t.replace(value.match));
            else {
                if (t.substitutes) {
                    if (t.substitutes instanceof Array) {
                        t.substitutes.forEach((v: ISubstitute, i: number) => {
                            if (v.substitute) {
                                if (typeof v.substitute === "function") {
                                    result.push(v.substitute(value.match[i + 1], this.props.state));
                                }
                                else
                                    result.push(v.substitute);
                            }
                        });
                    }
                    else
                        result.push({text: t.substitutes});
                }
            }
        });

        let elements: JSX.Element[] = [];
        let label: string = "";

        // now build the bread crumbs from the results
        // right now all bread crumbs will be ToolbarTitle components
        // they may have a string and/or an icon
        for (let i = 0; i < result.length; i++) {
            if (i > 0)
                elements.push(<div key={"split-" + i} className="breadCrumbsElement slash">{"/"}</div>);
            let link = i < result.length - 1 ? matchBox[i].link : "";
            let fct = link !== "" ? (() => this.navigateTo(link)) : undefined;
            let elementClassName = link ? "breadCrumbsElement textLink" : "breadCrumbsElement";
            if (result[i].icon)
                elements.push(
                    <Popup
                        className='custom-popup-home-icon'
                        key={"popup" + i}
                        trigger={
                            <Icon
                                key={"icon" + i}
                                className="breadCrumbsElement icon"
                                link={true}
                            >
                                <div key={"iconChild" + i} onClick={fct}>
                                    {result[i].icon}
                                </div>
                            </Icon>
                        }
                        content='Home'
                        position='bottom center'
                        inverted={true}
                    />

                );
            if (result[i].text !== "") {
                if (!result[i].noTranslation) {
                    elements.push(<div key={i} className={elementClassName} onClick={fct} >{this.props.t(result[i].text.toUpperCase(), result[i].options)}</div>);
                    label = label + "/" + this.props.t(result[i].text.toUpperCase(), result[i].options);
                }
                else {
                    elements.push(<div key={i} className={elementClassName} onClick={fct} >{result[i].text}</div>);
                    label = label + "/" + result[i].text;
                }
            }

            if (_.startsWith(label, "/PSL"))
                label = label + "/" + currentLinkName;
        }
        const {baseLinks, client} = this.props;
        // const isPSL = baseLinks && client.GET_pslExtraLinks(baseLinks).canExecute();
        // const isOptionBasic = baseLinks && client.GET_optionBasicExtraLinks(baseLinks).canExecute();
        // const isDerivate = baseLinks && client.GET_modeltypeBasicExtraLinks(baseLinks).canExecute();
        const isTopSlideVisible = true; // isPSL || isOptionBasic || isDerivate;
        // return a toolbar containing the menu and the bread crumbs
        return (
            <Header className={getClassBasedOnEnvironment('bread-crumbs-header')} as={Menu} block={true} inverted={true} size="large">
                <div className='header-row'>
                    <SlideFromLeft />
                    {elements}
                    <div className='right'>
                        <Modal
                            onClose={() => this.setState({open: false})}
                            onOpen={() => this.setState({
                                open: true,
                                department: (this.props.userDetails && this.props.userDetails.department) ? this.props.userDetails.department : '',
                                email: (this.props.userDetails && this.props.userDetails.email) ? this.props.userDetails.email : '',
                                isValid: (this.props.userDetails && this.props.userDetails.department && this.props.userDetails && this.props.userDetails.email) ? true : false
                            })}
                            open={this.state.open}
                            size='small'
                            trigger={<Icon size='large' name="info circle" className={getClassBasedOnEnvironment('info-popup')} />}
                        >
                            <ModalHeader>{this.props.t("PERSONAL_INFORMATION")}</ModalHeader>
                            <ModalContent scrolling={true}>
                                <ModalDescription>
                                    <Table basic='very'>
                                        <Table.Body>
                                            <Table.Row>
                                                <Table.HeaderCell width={3}>{this.props.t("USERNAME")}<b>*</b></Table.HeaderCell>
                                                <Table.Cell >
                                                    <TextField
                                                        disabled={true}
                                                        value={this.props.userDetails ? this.props.userDetails.cn : ''}
                                                    />
                                                </Table.Cell>
                                            </Table.Row>
                                            <Table.Row>
                                                <Table.HeaderCell width={3}>{this.props.t("NAME")}<b>*</b></Table.HeaderCell>
                                                <Table.Cell >
                                                    <TextField
                                                        disabled={true}
                                                        value={this.props.userDetails ? this.props.userDetails.displayName : ''}
                                                    />
                                                </Table.Cell>
                                            </Table.Row>
                                            <Table.Row>
                                                <Table.HeaderCell width={3}>{this.props.t("DEPARTMENT")}<b>*</b></Table.HeaderCell>
                                                <Table.Cell >
                                                    <TextField
                                                        value={this.state.department}
                                                        onChange={(e: any) => {
                                                            this.setState({department: e.target.value}, () => {
                                                                this.setState({isValid: this.isValidData()});
                                                            });
                                                        }
                                                        }
                                                    />
                                                </Table.Cell>
                                            </Table.Row>
                                            <Table.Row>
                                                <Table.HeaderCell width={3}>{this.props.t("EMAIL")}<b>*</b></Table.HeaderCell>
                                                <Table.Cell >
                                                    <TextField
                                                        value={this.state.email}
                                                        onChange={(e: any) => {
                                                            this.setState({email: e.target.value}, () => {
                                                                this.setState({isValid: this.isValidData()});
                                                            });
                                                        }}
                                                    />
                                                </Table.Cell>
                                            </Table.Row>
                                        </Table.Body>
                                    </Table>
                                </ModalDescription>
                            </ModalContent>
                            <ModalActions>
                                <Button key={1} icon={"checkmark"} disabled={!this.state.isValid} onClick={() => this.onUpdateInfo()} />
                                <Button key={2} icon={"ban"} onClick={() => this.setState({open: false})} />
                            </ModalActions>
                        </Modal>
                        {this.renderUserDetails(this.props.userDetails)}
                        <AppBar
                            t={this.props.t}
                            logoElement={<ProMTLogo color="Black_small" />}

                            switchHeaderMode={this.props.switchHeaderMode}
                            factoryResetTooltip={this.props.t("FACTORY_RESET_TOOLTIP")}
                            factoryResetLabel={this.props.t("SIDEBAR:FACTORY_SETTINGS")}
                            hasSupportRole={hasSupportRole}
                            hasChatbotRole={hasChatbotRole}
                            logoutLabel={this.props.t("LOGOUT")}
                            logoutTooltip={this.props.t("LOGOUT_TOOLTIP")}
                            changeLanguageTooltip={this.props.t("SWITCH_LANGUAGE")}
                            subscriptionTooltip={this.props.t("PSL_SUBSCRIPTION_TOOLTIP")}
                            onFactoryReset={this.props.reset}
                            onLogout={this.logout}
                            onChangeLanguage={this.props.changeLanguage}
                            onChangeTableHeader={this.props.changeTableHeader}
                            onManagementIconClick={() => {
                                this.props.history.push("/managementview");
                            }}
                        />
                    </div>
                </div>
                <SlideFromTop isTopSlideVisible={isTopSlideVisible} />
            </Header>
        );
    }

    render() {
        if (this.props.userSettings) {
            let lng = this.props.userSettings.language;
            if (this.props.i18n.language !== lng)
                this.props.i18n.changeLanguage(lng);
        }

        return (
            <div className='bread-crumbs-container'>
                {this.renderBreadCrumbs()}
            </div>
        );
    }
}

const mapStateToProps = (state: IReduxState): IMapStateToProps => ({
    client: selectClient(state),
    baseLinks: selectBaseLinks(state),
    locationTranslations: selectLocationTranslations(state),
    userSettings: selectUserSettings(state),
    userDetails: selectUserDetails(state),
    switchHeaderMode: selectSwitchHeaderMode(state),
    maintenanceStatus: selectMaintenanceStatus(state),
    state,
});

const mapDispatchToProps = (dispatch: Dispatch<IReduxState>, ownProps: BreadCrumbsProps): IMapDispatchToProps => ({
    changeLanguage: () => dispatch(GeneralActions.ChangeLanguage(ownProps.t("NEXT_LANGUAGE"))),
    changeTableHeader: () => dispatch(GeneralActions.ChangeTableHeaderMode()),
    reset: () => dispatch(GeneralActions.ResetToFactoryUserSettings()),
});

export default compose<React.ComponentType<IOwnProps>>(
    withRouter,
    translate("SIDEBAR"),
    connect<IMapStateToProps, IMapDispatchToProps>(mapStateToProps, mapDispatchToProps)
)(BreadCrumbs);



// WEBPACK FOOTER //
// ./src/views/BreadCrumbs.tsx